module.exports = __webpack_public_path__ + "img/page-avatar-two.ba6f8cc8.svg";